import React, { useState, useEffect } from "react";
import Menu from "../../../components/layout/menu/index";
import { pdfjs } from 'react-pdf';
import FilterInput from "../../../components/filters/filterInput";
import PdfCard from "../../../components/card/pdfCard";
import banner from "../../../assets/images/logos/banner-manuals.svg"
import { useModuleAdherence } from "../../../hooks/userAdherence";
import { axiosInstance } from '../../../client';

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.8.69/pdf.worker.mjs`;

export default function Manuals() {
  useModuleAdherence(8);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const [loading, setLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const [sections, setSections] = useState([]);
  const [activePdf, setActivePdf] = useState(null);
  const [activePdfBlobUrl, setActivePdfBlobUrl] = useState(null);
  const [activePdfError, setActivePdfError] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");

  const handleDownload = async (title, file) => {
    const response = await fetch(file);
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = title;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  };

  const fetchManuals = async () => {
    setLoading(true);
    setShowError(false);
    try {
      const res = await axiosInstance.get('/Manual/ListSections');
      setSections(res.data.sections);
    } catch {
      setErrorMessage('No se pudieron cargar los manuales.');
      setShowError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchManuals();
  }, []);

  useEffect(() => {
    let objectUrl;
    let cancelled = false;

    setActivePdfBlobUrl(null);
    setActivePdfError(false);

    if (!activePdf) return;

    axiosInstance.get(activePdf, { responseType: 'blob' })
      .then(response => {
        if (cancelled) return;
        objectUrl = URL.createObjectURL(response.data);
        setActivePdfBlobUrl(objectUrl);
      })
      .catch(err => {
        console.error('Error al cargar el documento:', err);
        if (!cancelled) setActivePdfError(true);
      });

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [activePdf]);

  return (
    <div>
      <Menu isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} className="transition-all duration-300" />
      <div className={`flex-1 pt-[67px] transition-all duration-300 ${isMenuOpen ? "xl:pl-[20.7%] lg:pl-[23.7%] pl-0" : "pl-0"} bg-[#F7F8F9] w-full z-50 min-h-screen`}>
        <div className="sm:pt-8 pt-5 pb-10 sm:px-[3%] px-[5%] flex flex-col gap-4">
          <img src={banner} alt="Manuales de información" className="object-cover h-[194px] w-full" />
          <div className="flex items-center justify-start w-full sm:justify-end">
            <FilterInput
              title="Buscar"
              placeholder="Escriba título del manual"
              value={searchTerm}
              classname="w-[200px]"
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          {sections.map((section) => {
            const filteredManuals = section.manuals?.filter((manual) =>
              manual.visible && manual.title.toLowerCase().includes(searchTerm.toLowerCase())
            );

            if (!filteredManuals || filteredManuals.length === 0) {
              return null;
            }
            return (
              <div className="flex flex-col gap-4" key={section.name}>
                <h2 className="font-itcdemi text-[5.7vw] sm:text-[3.7vw] lg:text-[1.7vw] text-[#184A7D]">
                  {section.name}
                </h2>
                <div className={`flex gap-6 pb-3 overflow-x-auto lg:gap-3 lg:grid xl:grid-cols-4 ${isMenuOpen ? "lg:grid-cols-3" : "lg:grid-cols-4"}`}>
                  {filteredManuals?.length ? filteredManuals.map((manual) => (
                    <PdfCard
                      key={manual.title}
                      pdfFile={manual.file}
                      title={manual.title}
                      onViewClick={() => setActivePdf(manual.file)}
                      onDownloadClick={() => handleDownload(manual.title, manual.file)}
                    />
                  )) : <p>No hay manuales disponibles.</p>}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {activePdf && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="flex flex-col w-[80vw] h-[80vh] bg-white rounded-lg shadow-lg overflow-hidden">
            <div className="flex justify-end p-4 bg-gray-100">
              <button
                onClick={() => setActivePdf(null)}
                className="text-3xl leading-none text-gray hover:text-gray-700"
              >
                &times;
              </button>
            </div>
            <div className="flex items-center justify-center flex-1">
              {activePdfError ? (
                <p className="text-gray-500 font-itcbook">El archivo no existe.</p>
              ) : activePdfBlobUrl ? (
                <iframe
                  src={activePdfBlobUrl}
                  title="Ver Manual"
                  className="w-full h-full"
                />
              ) : (
                <svg className="w-10 h-10 text-blue-600 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
                </svg>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}